import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import { toJS } from '../../../../utils/ChangeSpy';

import { Card } from '../../../helpers/Card';
import { OneRowTable } from './OneRowTable';
import { EventsTable } from './EventsTable';

import style from './style.module.css';

const MidBlockComponent = ({ data, onAddEvent, onEventRemove, yearFilter }) => (
  <div className={style.host}>
    <Card title="Events" flush>
      <EventsTable events={toJS(data.get('events'))} onAddEvent={onAddEvent} onEventRemove={onEventRemove} />
    </Card>
    <Card actions={<span className="text-muted">Year: {yearFilter}</span>} title="Statistics" flush>
      <OneRowTable companies={toJS(data.get('companies'))} rowData={toJS(data.get('statistics'))} />
    </Card>
  </div>
);

MidBlockComponent.propTypes = {
  data: PropTypes.instanceOf(Map).isRequired,
  onAddEvent: PropTypes.func,
  onEventRemove: PropTypes.func,
  yearFilter: PropTypes.string,
};

/** Mid block component. */
export const MidBlock = memo(MidBlockComponent);
